import React from 'react';

type Kind = 'home' | 'about' | 'work' | 'blog' | 'faq' | 'gallery';

interface ScreenProps {
  kind: Kind;
  title: string;
}

/**
 * Hero section with background image
 */
const Screen: React.FC<ScreenProps> = ({ kind }) => (
  <section className={`screen screen-${kind}`} aria-label="hero">
    <div className="screen-overlay"></div>
  </section>
);

export default Screen;
